/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Payment_Terms_UpfrontInputs */

const en_clients_payment_terms_upfront = /** @type {(inputs: Clients_Payment_Terms_UpfrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upfront`)
};

const pt_br2_clients_payment_terms_upfront = /** @type {(inputs: Clients_Payment_Terms_UpfrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À vista`)
};

/**
* | output |
* | --- |
* | "Upfront" |
*
* @param {Clients_Payment_Terms_UpfrontInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_payment_terms_upfront = /** @type {((inputs?: Clients_Payment_Terms_UpfrontInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Payment_Terms_UpfrontInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_payment_terms_upfront(inputs)
	return pt_br2_clients_payment_terms_upfront(inputs)
});